import React from 'react'

import { Construction } from 'lucide-react'

interface FeatureNotEnabledProps {
    moduleName?: string
}

export default function FeatureNotEnabled({ moduleName }: FeatureNotEnabledProps) {
    return (
        <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4 mb-6 flex items-start gap-3 animate-in fade-in duration-300">
            <Construction size={20} className="text-amber-400 mt-0.5 shrink-0" />
            <div>
                <h3 className="text-amber-400 font-bold text-sm">
                    ⚠️ Función en desarrollo
                </h3>
                <p className="text-gray-400 text-xs mt-1 leading-relaxed">
                    {moduleName
                        ? `El módulo "${moduleName}" es una referencia técnica y buenas prácticas. La integración automática con el agente vendor_core aún no está habilitada en esta versión.`
                        : 'Este módulo es una referencia técnica. La integración automática con el agente vendor_core aún no está habilitada en esta versión.'
                    }
                </p>
            </div>
        </div>
    )
}
